var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_1b974da6"]},_vm.$listeners),[_c('div',{class:["cube-loading"]},[_c('div',{class:["cube-loading-content"]},[_c('div',{class:["cube-loading-origin"]},[_c('div',{class:["cube-loading-middle-dot"]})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }